import { useFeatureFlag } from '@artic/ui/feature-flags';
import { createFileRoute } from '@tanstack/react-router';

import { usePartnerId } from '../../features/inbox/use-partner-name';
import { OverheadsView } from '../../features/operating-costs/overheads-view';

export const Route = createFileRoute('/operating-costs/overheads')({
  staticData: {
    breadcrumb: 'Overheads',
  },
  component: OverheadsPage,
});

/**
 * Renders the overheads page when operating costs are enabled, or an unavailable message otherwise.
 */
function OverheadsPage() {
  const enabled = useFeatureFlag('operating_costs');
  const partnerId = usePartnerId();

  if (!enabled) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 py-20">
        <h2 className="text-lg font-semibold">Feature not available</h2>
        <p className="text-muted-foreground text-sm">
          Operating costs are not enabled for your organisation.
        </p>
      </div>
    );
  }

  return <OverheadsView partnerId={partnerId} />;
}
